module.exports = __webpack_public_path__ + "img/bronzeShadowMob.8ed72b7a.webp";